<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="단지안내" tabActive="층별 호수 배치도" bg="/images/sub/complex/visual.jpg">
                <template #title>단지안내</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <template #tit>층별 호수 배치도</template>

            <div class="page-section__content">
                <div class="floor-tabs">
                    <v-tabs grow hide-slider centered v-model="tab" class="v-tabs--density-compact">
                        <template v-for="(item, index) in items">
                            <tab-quarternary :key="index">{{ item }}층</tab-quarternary>
                        </template>
                    </v-tabs>
                </div>
            </div>

            <div class="page-section__content">
                <sheet-secondary min-height="400" class="pa-0" align="center">
                    <v-tabs-items v-model="tab">
                        <template v-for="(item, index) in items">
                            <v-tab-item :key="index" eager>
                                <img :src="`/images/sub/complex/floor/floor-${item}.jpg`" alt="" />
                            </v-tab-item>
                        </template>
                    </v-tabs-items>
                </sheet-secondary>
            </div>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import TabQuarternary from "@/components/publish/parents/tabs/tab-quarternary.vue";
import SheetSecondary from "@/components/publish/parents/sheets/sheet-secondary.vue";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";
import UBtnFlatPill from "@/components/publish/styles/buttons/u-btn-flat-pill.vue";
import UTxtDefault from "@/components/publish/styles/typography/u-txt-default.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        TabQuarternary,
        SheetSecondary,
        UTitDefault,
        UBtnFlatPill,
        UTxtDefault,
    },
    data: () => ({
        tab: null,

        items: [
            "5",
            "6~26",
            "27",
            //
        ],
    }),
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.floor-tabs {
    ::v-deep {
        .v-tab--button {
            --tab-margin-compact: 6px !important;
        }
        .v-tabs-bar__content {
            flex-wrap: wrap;
            max-width: 100%;
        }
        .v-tabs--grow > .v-tabs-bar .v-tab {
            flex: 0 0 calc(100% / 3 - 12px) !important;
        }
    }
}
@media (min-width: 768px) {
    .floor-tabs {
        ::v-deep {
            .v-tabs--grow > .v-tabs-bar .v-tab {
                flex: 0 0 calc(100% / 3 - 12px) !important;
            }
        }
    }
}
</style>
